import React from "react";
import {
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormGroup,
  Box,
  Paper,
  Divider,
  Chip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ReactComponent as AddIcon } from "Assets/Icons/AddIcon.svg";
import { ReactComponent as EditIconTwo } from "Assets/Icons/EditIconTwo.svg";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import { ReactComponent as AddOrderToList } from "Assets/Icons/AddOrderToList.svg";
import { ReactComponent as CreateNewRxOrder } from "Assets/Icons/CreateNewRxOrder.svg";
import clsx from "clsx";
import PageLoading from "Components/Common/PageLoading";
import PrimaryIcon from "Components/Common/PrimaryIcon";

import useViewport from "Hooks/useViewport";

import { useSelector } from "react-redux";

import RepeatOrderPatientAutoComplete from "Components/RepeatOrder/RepeatOrderPatientAutoComplete";
import SurgryAutoComplete from "Components/Patients/SurgeryAutoComplete";
import PharmacyAutoComplete from "Components/Patients/PharmacyAutoComplete";
// const RepeatOrderPatientAutoComplete = React.lazy(() =>
//   import("Components/RepeatOrder/RepeatOrderPatientAutoComplete")
// );
// const SurgryAutoComplete = React.lazy(() =>
//   import("Components/Patients/SurgeryAutoComplete")
// );
// const PharmacyAutoComplete = React.lazy(() =>
//   import("Components/Patients/PharmacyAutoComplete")
// );

const useStyle = makeStyles((theme) => ({
  rsOrderPadGrid: {
    "&>div": {
      marginBottom: "30px",
      "&>h3": {
        fontSize: "20px !important",
      },
      "&>hr": {
        backgroundColor: theme.palette.background.grey,
        marginTop: "10px",
      },
    },
  },
  rsOrderPadGeneralInfo: {
    padding: "17px 13px 25px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    marginBottom: "73px",
    "&>h3": {
      fontSize: "20px !important",
      marginBottom: "30px",
    },
    "&>div": {
      "&>h4": {
        marginBottom: "20px",
      },
      "&>div": {
        marginBottom: "20px",
      },
    },
    "&>hr": {
      marginBottom: "30px",
      background: `${theme.palette.background.grey} !important`,
    },
  },
  rsOrderPadPatientSelect: {
    padding: "17px 13px",
    height: "296px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    "&>h3": {
      fontSize: "20px !important",
      marginBottom: "30px",
    },
    "&>hr": {
      marginBottom: "30px",
      background: `${theme.palette.background.grey} !important`,
    },
  },
  rsOrderPadBtn: {
    padding: "9px 0px",
    height: "100px",
    width: "72%",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    "&>h3": {
      fontSize: "20px !important",
      marginBottom: "30px",
    },
    "&>hr": {
      marginBottom: "30px",
      background: `${theme.palette.background.grey} !important`,
    },
  },
  rsOrderPadMedicationBtn: {
    padding: "17px 13px 5px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "10px !important",
    backgroundColor: "none !important",
    marginBottom: "30px",
  },
  rsOrderPadProceedBtn: {
    marginRight: "60px !important",
    fontSize: "14px !important",
    fontWeight: "400 !important",
    borderRadius: "5px !important",
    marginBottom: "50px !important",
  },
  rsPatientEditBtn: {
    fontSize: "14px !important",
    fontWeight: "400 !important",
    borderRadius: "5px !important",
    marginBottom: "0px !important",
    marginLeft: "20px !important",
  },
  rsPatientCreateBtn: {
    marginTop: "20px !important",
    margin: "10px !important",
    whiteSpace: "nowrap",
  },
  rsPatientCreateBtnNew: {
    // marginTop: "20px !important",
    margin: "10px !important",
    whiteSpace: "nowrap",
  },
  tableBody: {
    "&>td": {
      padding: "10px 20px !important",
    },
    "& .MuiFormControlLabel-root": {
      marginLeft: "11px !important",
    },
  },
  labelWhiteSpaceNW: {
    "&>span": {
      whiteSpace: "nowrap",
    },
  },
  orderDetailTitle: {
    marginBottom: "0px !important",
  },
  chipMain: {
    position: "relative",
    marginLeft: "10px",
    marginTop: "10px",
    height: "50px !important",
    minWidth: "170px !important",
    borderRadius: "5px !important",
    padding: "8px 20px !important",
    fontSize: "16px !important",
    cursor: "pointer  !important",
    "& .MuiChip-icon": {
      marginBottom: "5px !important",
      margin: "0px !important",
    },
    "&>svg": {
      width: "20px",
      height: "20px",
    },
    "&>span": {
      marginLeft: "10px  !important",
      padding: "0px  !important",

      "&>div": {
        "&>svg": {
          position: "absolute",
          top: "3px",
          right: "3px",
          width: "18px",
          height: "18px",
        },
      },
    },
  },
  chips: {
    borderColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.main} !important`,
    background: `${theme.palette.primary.main}10 !important`,
    "&>svg": {
      "&>path": {
        fill: `${theme.palette.primary.main} !important`,
      },
    },
    "&:hover": {
      background: `${theme.palette.primary.main}20 !important`,
    },
  },
  chipsFilled: {
    borderColor: `${theme.palette.primary.main} !important`,
    color: `#ffffff !important`,
    background: `${theme.palette.primary.main} !important`,
    "&>svg": {
      "&>path": {
        fill: ` #ffffff !important`,
      },
    },
    "&:hover": {
      background: `rgb(86, 134, 47) !important`,
    },
  },
  rsPharmacyAutocomplete: {
    marginBottom: "10px !important",
  },
  rsFromGroup: {
    marginLeft: "10px !important",
  },
  rsMainGrid: {
    marginTop: "20px !important",
    marginBottom: "20px !important",
    justifyContent: "space-around !important",
  },
  rsbtnSmallScreen: {
    "&>div": {
      "&>button": {
        marginLeft: "0px !important",
      },
    },
  },
  buttonPatient: {
    "&>button": {
      fontSize: "14px !important",
    },
  },
}));

const CreateNewRx = (props) => {
  const classes = useStyle();
  const {
    handleSubmit,
    selectedPatientInfo,
    query,
    setSelectedPatientInfo,
    setFieldValue,
    handlePatientDetailsChange,
    currentPageType,
    touched,
    repeatOrderToOrderPad,
    errors,
    values,
    handleChange,
    OrderBYList,
    orderBy,
    setOrderBy,
    navigate,
    orderType,
    showMedication,
    setOrderType,
    setShowMedication,
    setShowNoOfMedication,
    showNoOfMedication,
    checkAllAction,
    setCheckAllAction,
    medications,
    setMedications,
    handleChangeAction,
    medicationActionCheck,
    handleBlur,
    setCreateDrug,
    showWholeForm,
    createOrderPadData,
    showOrderList,
    setShowOrderList,
    setShowCreateNewRx,
    showCreateNewRx,
    choosePatientShow,
    setIsOpenOrderList,
    handleDialog,
    setIsOpenNewPatientPopup,
    setOrderPadData,
    formState,
    setShowWholeForm,
    OrderingMethod,
  } = props;

  const { width } = useViewport();

  const loginUserDetail = useSelector((state) => state.user);
  const showDataBasedOnRole =
    loginUserDetail?.loginUserDetail?.data?.data?.role;
  return (
    <>
      <Grid
        container
        columnSpacing={2.5}
        rowSpacing={3}
        className={classes.rsOrderPadGrid}
      >
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <Paper elevation={0} className={classes.rsOrderPadBtn}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Box display={"flex"} justifyContent={"space-evenly"}>
                <Button
                  className={classes.rsPatientCreateBtn}
                  variant="outlined"
                  startIcon={
                    <PrimaryIcon
                      icon={AddOrderToList}
                      color="primary"
                      width="20px"
                      height="20px"
                    />
                  }
                  onClick={() => {
                    setOrderType("addOrder");
                    setShowOrderList(true);
                    setShowCreateNewRx(false);
                    setOrderPadData(formState);
                    setShowWholeForm(false);
                    setSelectedPatientInfo({});
                  }}
                >
                  Add Order To List
                </Button>
                <Button
                  className={classes.rsPatientCreateBtn}
                  variant="outlined"
                  startIcon={
                    <PrimaryIcon
                      icon={CreateNewRxOrder}
                      color="primary"
                      width="20px"
                      height="20px"
                    />
                  }
                  onClick={() => {
                    setOrderType("createNewOrder");
                    setShowCreateNewRx(true);
                    setShowOrderList(false);
                    setOrderPadData(formState);
                    setShowWholeForm(false);
                    setSelectedPatientInfo({});
                  }}
                >
                  Order New RX
                </Button>
              </Box>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      {orderType === "addOrder" && (
        <Grid>
          {repeatOrderToOrderPad?.loading ? (
            <PageLoading />
          ) : (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <Grid
                container
                columnSpacing={2.5}
                rowSpacing={3}
                className={classes.rsOrderPadGrid}
              >
                {orderType === "addOrder" &&
                  (showOrderList || choosePatientShow) && (
                    <Grid item xs={5} sm={5} md={5} lg={4} xl={5}>
                      <Paper
                        elevation={0}
                        className={classes.rsOrderPadPatientSelect}
                      >
                        <Typography variant="h3" medium color="secondary">
                          Choose Patient Name
                        </Typography>
                        <Divider />
                        <Box display={"flex"} alignItems={"center"}>
                          <RepeatOrderPatientAutoComplete
                            fullWidth
                            value={selectedPatientInfo}
                            disabled={
                              query.get("actionType") === "repeatOrderPage"
                            }
                            className={classes.autoCompleteBox}
                            onChange={(e, value) => {
                              setSelectedPatientInfo(value);
                              setFieldValue("patient_id", value?.id);
                              handlePatientDetailsChange(value);
                            }}
                            currentPageType={currentPageType}
                            orderType={orderType}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                autoFocus
                                label="Choose Patient Name *"
                                error={
                                  touched?.patient_id && errors?.patient_id
                                }
                                helperText={
                                  touched?.patient_id && errors?.patient_id
                                }
                              />
                            )}
                          />
                          {width > 1540 && (
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                              <Button
                                className={classes.rsPatientCreateBtnNew}
                                variant="outlined"
                                disabled={values?.patient_id}
                                startIcon={
                                  <PrimaryIcon
                                    icon={AddIcon}
                                    color="primary"
                                    width="16px"
                                    height="16px"
                                  />
                                }
                                onClick={() => {
                                  setIsOpenNewPatientPopup(true);
                                }}
                              >
                                Create New Patient
                              </Button>
                            </Grid>
                          )}
                        </Box>

                        {width < 1540 && (
                          <Box className={classes.rsbtnSmallScreen}>
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                              <Button
                                className={classes.rsPatientCreateBtnNew}
                                variant="outlined"
                                disabled={values?.patient_id}
                                startIcon={
                                  <PrimaryIcon
                                    icon={AddIcon}
                                    color="primary"
                                    width="16px"
                                    height="16px"
                                  />
                                }
                                onClick={() => {
                                  setIsOpenNewPatientPopup(true);
                                }}
                              >
                                Create New Patient
                              </Button>
                            </Grid>
                          </Box>
                        )}
                      </Paper>
                    </Grid>
                  )}
                {showWholeForm && (
                  <>
                    <Grid item xs={7} sm={7} md={7} lg={8} xl={7}>
                      <Paper
                        elevation={0}
                        className={classes.rsOrderPadGeneralInfo}
                      >
                        <Typography variant="h3" medium color="secondary">
                          General Information
                        </Typography>
                        <Divider />
                        <Box display={"flex"}>
                          <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            lg={6}
                            marginRight={"20px"}
                          >
                            <TextField
                              disabled
                              className={classes.marginTop}
                              variant="outlined"
                              fullWidth
                              placeholder="Name *"
                              label="Name *"
                              size="small"
                              InputLabelProps={{ shrink: true }}
                              name="name"
                              value={values?.name}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            />
                          </Grid>
                          <Grid item xs={6} sm={6} md={6} lg={6}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                disabled
                                className={classes.marginTop}
                                disableFuture
                                label="Date of birth *"
                                views={["year", "month", "day"]}
                                inputFormat="DD-MM-YYYY"
                                value={values?.dob}
                                onChange={(newDate) => {
                                  setFieldValue("dob", newDate);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    className={classes.marginTop}
                                    fullWidth
                                    size="small"
                                    name="dob"
                                    {...params}
                                  />
                                )}
                                name="dob"
                              />
                            </LocalizationProvider>
                          </Grid>
                        </Box>
                        <Box display={"flex"}>
                          <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            lg={6}
                            marginRight={"20px"}
                          >
                            <SurgryAutoComplete
                              disabled
                              fullWidth
                              // multiple
                              className={classes.autoCompleteBox}
                              value={values?.surgery_info}
                              onChange={(e, value) => {
                                setFieldValue("surgery_info", value);
                                setFieldValue("surgery_id", value.id);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  className={classes.marginTop}
                                  {...params}
                                  label="Surgery *"
                                />
                              )}
                            />
                          </Grid>
                          {showDataBasedOnRole === "admin" && (
                            <Grid
                              item
                              xs={6}
                              sm={6}
                              md={6}
                              lg={6}
                              className={classes.rsPharmacyAutocomplete}
                            >
                              <PharmacyAutoComplete
                                disabled
                                fullWidth
                                // multiple
                                className={classes.autoCompleteBox}
                                value={values?.pharmacy_info}
                                onChange={(e, value) => {
                                  setFieldValue("pharmacy_info", value);
                                  setFieldValue("pharmacy_id", value.id);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    className={classes.marginTop}
                                    {...params}
                                    label="Pharmacy *"
                                  />
                                )}
                              />
                            </Grid>
                          )}
                        </Box>
                        <Box display={"flex"}>
                          {OrderBYList?.map((item, index) => {
                            return (
                              <FormControlLabel
                                className={classes.labelWhiteSpaceNW}
                                value={item}
                                key={index}
                                checked={orderBy === item.type}
                                onChange={(e, value) => {
                                  setOrderBy(item.type);
                                }}
                                control={
                                  <Checkbox
                                    icon={<RadioButtonUncheckedIcon />}
                                    checkedIcon={<RadioButtonCheckedIcon />}
                                    color="primary"
                                  />
                                }
                                label={`${item.item}  ordered`}
                              />
                            );
                          })}
                        </Box>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Paper
                        elevation={0}
                        className={classes.rsOrderPadGeneralInfo}
                      >
                        <Typography variant="h3" medium color="secondary">
                          Medicine details
                        </Typography>
                        <Divider />
                        <Box display={"flex"}>
                          <FormGroup>
                            <FormControlLabel
                              className={classes.rsSurgryFormControl}
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={showMedication}
                                  onChange={() => {
                                    setShowMedication(!showMedication);
                                    setShowNoOfMedication(false);
                                  }}
                                  icon={<RadioButtonUncheckedIcon />}
                                  checkedIcon={<RadioButtonCheckedIcon />}
                                />
                              }
                              label="Select Specific Medications"
                            />
                          </FormGroup>
                          <FormGroup>
                            <FormControlLabel
                              className={classes.rsSurgryFormControl}
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={showNoOfMedication}
                                  onChange={() => {
                                    setShowNoOfMedication(!showNoOfMedication);
                                    setShowMedication(false);
                                  }}
                                  icon={<RadioButtonUncheckedIcon />}
                                  checkedIcon={<RadioButtonCheckedIcon />}
                                />
                              }
                              label="Select Number Of Medications"
                            />
                          </FormGroup>
                        </Box>
                        {showMedication && (
                          <Grid item xs={12}>
                            <Table stickyHeader>
                              <TableHead>
                                <TableRow>
                                  <TableCell style={{ width: "50%" }}>
                                    <div style={{ display: "flex" }}>
                                      DRUG{" "}
                                      <div
                                        style={{
                                          color: "red",
                                          marginLeft: "5px",
                                        }}
                                      >
                                        *
                                      </div>{" "}
                                    </div>
                                  </TableCell>
                                  <TableCell style={{ width: "10%" }}>
                                    QUANTITY
                                  </TableCell>
                                  <TableCell style={{ width: "5%" }}>
                                    <Box
                                      display={"flex"}
                                      alignItems={"center"}
                                      justifyContent={"space-around"}
                                    >
                                      ACTION
                                      <FormGroup
                                        className={classes.rsFromGroup}
                                      >
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              color="primary"
                                              checked={checkAllAction}
                                              onChange={(e, value) => {
                                                const isChecked =
                                                  !checkAllAction;
                                                setCheckAllAction(isChecked);

                                                //Tick untick medication
                                                const _medications =
                                                  medications?.map((item) => {
                                                    item.action = isChecked;
                                                    return item;
                                                  });
                                                setMedications(_medications);
                                              }}
                                            />
                                          }
                                        />
                                      </FormGroup>
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {medications?.map((item, index) => {
                                  return (
                                    <TableRow className={classes.tableBody}>
                                      <TableCell>
                                        <TextField
                                          variant="outlined"
                                          fullWidth
                                          disabled
                                          placeholder="Drug"
                                          label="Drug"
                                          size="small"
                                          name="drug"
                                          value={item.name}
                                          onChange={handleChange}
                                          InputLabelProps={{
                                            shrink: item.name,
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <TextField
                                          variant="outlined"
                                          fullWidth
                                          disabled
                                          inputProps={{ maxLength: 10 }}
                                          placeholder="Quantity"
                                          label="Quantity"
                                          size="small"
                                          value={item.quantity}
                                          name="quantity"
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <FormGroup>
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                color="primary"
                                                checked={item?.action}
                                                onChange={(e, value) => {
                                                  handleChangeAction(e, index);
                                                }}
                                              />
                                            }
                                          />
                                        </FormGroup>
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </Grid>
                        )}
                        {showNoOfMedication && (
                          <Grid item xs={4} sm={4} md={4} lg={4}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              placeholder="Total Medication"
                              label="Total Medication"
                              size="small"
                              type="number"
                              name="number_of_medication"
                              value={values?.number_of_medication}
                              error={
                                touched?.number_of_medication &&
                                errors?.number_of_medication
                              }
                              helperText={
                                touched?.number_of_medication &&
                                errors?.number_of_medication
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              InputLabelProps={{
                                shrink:
                                  query.get("actionType") ===
                                    "repeatOrderPage" ||
                                    repeatOrderToOrderPad?.data
                                      ?.number_of_medication ||
                                    showNoOfMedication
                                    ? true
                                    : false,
                              }}
                            />
                          </Grid>
                        )}
                      </Paper>
                      <Grid item xs={6} sm={6} md={12} lg={12}>
                        <Box className={classes.buttonPatient}>
                          <Button
                            className={classes.rsPatientEditBtn}
                            variant="contained"
                            disabled={
                              values?.number_of_medication !== "" &&
                              medicationActionCheck.length === 0
                            }
                            startIcon={
                              <PrimaryIcon
                                icon={EditIconTwo}
                                color="white"
                                width="16px"
                                height="16px"
                              />
                            }
                            onClick={() => {
                              setCreateDrug(true);
                            }}
                          >
                            Edit Patient
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Paper
                        elevation={0}
                        className={classes.rsOrderPadMedicationBtn}
                      >
                        <Grid
                          container
                          columnSpacing={2.5}
                          rowSpacing={3}
                          className={classes.rsOrderPadGrid}
                        >
                          <Grid
                            item
                            xs={12}
                            className={classes.orderDetailTitle}
                          >
                            <Typography variant="h3" medium color="secondary">
                              Order Details
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                          <Grid item xs={6} sm={6} md={6} lg={6}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                disablePast
                                label="Order Date *"
                                views={["year", "month", "day"]}
                                inputFormat="DD-MM-YYYY"
                                value={values?.order_date}
                                minDate={new Date()}
                                onChange={(newDate) => {
                                  setFieldValue("order_date", newDate);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    fullWidth
                                    size="small"
                                    name="order_date"
                                    {...params}
                                    error={
                                      touched?.order_date && errors?.order_date
                                    }
                                    helperText={
                                      touched?.order_date && errors?.order_date
                                    }
                                    onBlur={handleBlur}
                                  />
                                )}
                              />
                            </LocalizationProvider>
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>
                  </>
                )}
              </Grid>
              {showWholeForm && (
                <>
                  <Grid container columnSpacing={2.5} rowSpacing={2}>
                    <Box display={"flex"} margin={"0 auto"}>
                      <Grid item xs={6} sm={6} md={6} lg={6}>
                        <Button
                          variant="outlined"
                          onClick={() => navigate(process.env.REACT_APP_USE_PRESCRIPTION_TRACKING == "true" ? "/prescription-tracking" : "/rx-collection")}
                        >
                          Cancel
                        </Button>
                      </Grid>
                      <Grid item xs={3} sm={6} md={6} lg={6}>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={createOrderPadData?.loading}
                          startIcon={
                            createOrderPadData?.loading && (
                              <CircularProgress color="white" size="20px" />
                            )
                          }
                          className={classes.rsOrderPadProceedBtn}
                        >
                          Proceed
                        </Button>
                      </Grid>
                    </Box>
                  </Grid>
                </>
              )}
            </form>
          )}
        </Grid>
      )}
      {orderType === "createNewOrder" && (
        <Grid>
          {repeatOrderToOrderPad?.loading ? (
            <PageLoading />
          ) : (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <Grid
                container
                columnSpacing={2.5}
                rowSpacing={3}
                className={classes.rsOrderPadGrid}
              >
                {orderType === "createNewOrder" &&
                  (showCreateNewRx || choosePatientShow) && (
                    <Grid item xs={5} sm={5} md={5} lg={4} xl={5}>
                      <Paper
                        elevation={0}
                        className={classes.rsOrderPadPatientSelect}
                      >
                        <Typography variant="h3" medium color="secondary">
                          Choose Patient Name
                        </Typography>
                        <Divider />
                        <Box display={"flex"} alignItems={"center"}>
                          <RepeatOrderPatientAutoComplete
                            fullWidth
                            value={selectedPatientInfo}
                            disabled={
                              query.get("actionType") === "repeatOrderPage"
                            }
                            className={classes.autoCompleteBox}
                            onChange={(e, value) => {
                              setSelectedPatientInfo(value);
                              setFieldValue("patient_id", value?.id);
                              handlePatientDetailsChange(value);
                            }}
                            currentPageType={currentPageType}
                            orderType={orderType}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                autoFocus
                                label="Choose Patient Name *"
                                error={
                                  touched?.patient_id && errors?.patient_id
                                }
                                helperText={
                                  touched?.patient_id && errors?.patient_id
                                }
                              />
                            )}
                          />
                          {width > 1540 && (
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                              <Button
                                className={classes.rsPatientCreateBtnNew}
                                variant="outlined"
                                disabled={values?.patient_id}
                                startIcon={
                                  <PrimaryIcon
                                    icon={AddIcon}
                                    color="primary"
                                    width="16px"
                                    height="16px"
                                  />
                                }
                                onClick={() => {
                                  setIsOpenNewPatientPopup(true);
                                }}
                              >
                                Create New Patient
                              </Button>
                            </Grid>
                          )}
                        </Box>
                        {width < 1540 && (
                          <Box className={classes.rsbtnSmallScreen}>
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                              <Button
                                className={classes.rsPatientCreateBtnNew}
                                variant="outlined"
                                disabled={values?.patient_id}
                                startIcon={
                                  <PrimaryIcon
                                    icon={AddIcon}
                                    color="primary"
                                    width="16px"
                                    height="16px"
                                  />
                                }
                                onClick={() => {
                                  setIsOpenNewPatientPopup(true);
                                }}
                              >
                                Create New Patient
                              </Button>
                            </Grid>
                          </Box>
                        )}
                      </Paper>
                    </Grid>
                  )}
                {showWholeForm && (
                  <>
                    <Grid item xs={7} sm={7} md={7} lg={8} xl={7}>
                      <Paper
                        elevation={0}
                        className={classes.rsOrderPadGeneralInfo}
                      >
                        <Typography variant="h3" medium color="secondary">
                          General Information
                        </Typography>
                        <Divider />
                        <Box display={"flex"}>
                          <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            lg={6}
                            marginRight={"20px"}
                          >
                            <TextField
                              disabled
                              className={classes.marginTop}
                              variant="outlined"
                              fullWidth
                              placeholder="Name *"
                              label="Name *"
                              size="small"
                              InputLabelProps={{ shrink: true }}
                              name="name"
                              value={values?.name}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            />
                          </Grid>
                          <Grid item xs={6} sm={6} md={6} lg={6}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                disabled
                                className={classes.marginTop}
                                disableFuture
                                label="Date of birth *"
                                views={["year", "month", "day"]}
                                inputFormat="DD-MM-YYYY"
                                value={values?.dob}
                                onChange={(newDate) => {
                                  setFieldValue("dob", newDate);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    className={classes.marginTop}
                                    fullWidth
                                    size="small"
                                    name="dob"
                                    {...params}
                                  />
                                )}
                                name="dob"
                              />
                            </LocalizationProvider>
                          </Grid>
                        </Box>
                        <Box display={"flex"}>
                          <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            lg={6}
                            marginRight={"20px"}
                          >
                            <SurgryAutoComplete
                              disabled
                              fullWidth
                              // multiple
                              className={classes.autoCompleteBox}
                              value={values?.surgery_info}
                              onChange={(e, value) => {
                                setFieldValue("surgery_info", value);
                                setFieldValue("surgery_id", value.id);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  className={classes.marginTop}
                                  {...params}
                                  label="Surgery *"
                                />
                              )}
                            />
                          </Grid>
                          {showDataBasedOnRole === "admin" && (
                            <Grid
                              item
                              xs={6}
                              sm={6}
                              md={6}
                              lg={6}
                              className={classes.rsPharmacyAutocomplete}
                            >
                              <PharmacyAutoComplete
                                disabled
                                fullWidth
                                // multiple
                                className={classes.autoCompleteBox}
                                value={values?.pharmacy_info}
                                onChange={(e, value) => {
                                  setFieldValue("pharmacy_info", value);
                                  setFieldValue("pharmacy_id", value.id);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    className={classes.marginTop}
                                    {...params}
                                    label="Pharmacy *"
                                  />
                                )}
                              />
                            </Grid>
                          )}
                        </Box>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Paper
                        elevation={0}
                        className={classes.rsOrderPadGeneralInfo}
                      >
                        <Typography variant="h3" medium color="secondary">
                          Medicine details
                        </Typography>
                        <Divider />
                        <Box display={"flex"}>
                          <FormGroup>
                            <FormControlLabel
                              className={classes.rsSurgryFormControl}
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={showMedication}
                                  onChange={() => {
                                    setShowMedication(!showMedication);
                                    setShowNoOfMedication(false);
                                  }}
                                  icon={<RadioButtonUncheckedIcon />}
                                  checkedIcon={<RadioButtonCheckedIcon />}
                                />
                              }
                              label="Select Specific Medications"
                            />
                          </FormGroup>
                          <FormGroup>
                            <FormControlLabel
                              className={classes.rsSurgryFormControl}
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={showNoOfMedication}
                                  onChange={() => {
                                    setShowNoOfMedication(!showNoOfMedication);
                                    setShowMedication(false);
                                  }}
                                  icon={<RadioButtonUncheckedIcon />}
                                  checkedIcon={<RadioButtonCheckedIcon />}
                                />
                              }
                              label="Select Number Of Medications"
                            />
                          </FormGroup>
                        </Box>
                        {showMedication && (
                          <Grid item xs={12}>
                            <Table stickyHeader>
                              <TableHead>
                                <TableRow>
                                  <TableCell style={{ width: "50%" }}>
                                    <div style={{ display: "flex" }}>
                                      DRUG{" "}
                                      <div
                                        style={{
                                          color: "red",
                                          marginLeft: "5px",
                                        }}
                                      >
                                        *
                                      </div>{" "}
                                    </div>
                                  </TableCell>
                                  <TableCell style={{ width: "10%" }}>
                                    QUANTITY
                                  </TableCell>
                                  <TableCell style={{ width: "5%" }}>
                                    <Box
                                      display={"flex"}
                                      alignItems={"center"}
                                      justifyContent={"space-around"}
                                    >
                                      ACTION
                                      <FormGroup
                                        className={classes.rsFromGroup}
                                      >
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              color="primary"
                                              checked={checkAllAction}
                                              onChange={(e, value) => {
                                                const isChecked =
                                                  !checkAllAction;
                                                setCheckAllAction(isChecked);

                                                //Tick untick medication
                                                const _medications =
                                                  medications?.map((item) => {
                                                    item.action = isChecked;
                                                    return item;
                                                  });
                                                setMedications(_medications);
                                              }}
                                            />
                                          }
                                        />
                                      </FormGroup>
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {medications?.map((item, index) => {
                                  return (
                                    <TableRow className={classes.tableBody}>
                                      <TableCell>
                                        <TextField
                                          variant="outlined"
                                          fullWidth
                                          disabled
                                          placeholder="Drug"
                                          label="Drug"
                                          size="small"
                                          name="drug"
                                          value={item.name}
                                          onChange={handleChange}
                                          InputLabelProps={{
                                            shrink: item.name,
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <TextField
                                          variant="outlined"
                                          fullWidth
                                          disabled
                                          inputProps={{ maxLength: 10 }}
                                          placeholder="Quantity"
                                          label="Quantity"
                                          size="small"
                                          value={item.quantity}
                                          name="quantity"
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <FormGroup>
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                color="primary"
                                                checked={item?.action}
                                                onChange={(e, value) => {
                                                  handleChangeAction(e, index);
                                                }}
                                              />
                                            }
                                          />
                                        </FormGroup>
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </Grid>
                        )}
                        {showNoOfMedication && (
                          <Grid item xs={4} sm={4} md={4} lg={4}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              placeholder="Total Medication"
                              label="Total Medication"
                              size="small"
                              type="number"
                              name="number_of_medication"
                              value={values?.number_of_medication}
                              error={
                                touched?.number_of_medication &&
                                errors?.number_of_medication
                              }
                              helperText={
                                touched?.number_of_medication &&
                                errors?.number_of_medication
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              InputLabelProps={{
                                shrink:
                                  query.get("actionType") ===
                                    "repeatOrderPage" ||
                                    repeatOrderToOrderPad?.data
                                      ?.number_of_medication ||
                                    showNoOfMedication
                                    ? true
                                    : false,
                              }}
                            />
                          </Grid>
                        )}
                      </Paper>
                      <Grid item xs={6} sm={6} md={12} lg={12}>
                        <Box className={classes.buttonPatient}>
                          <Button
                            className={classes.rsPatientEditBtn}
                            variant="contained"
                            disabled={
                              showNoOfMedication &&
                              medicationActionCheck.length === 0
                            }
                            startIcon={
                              <PrimaryIcon
                                icon={EditIconTwo}
                                color="white"
                                width="16px"
                                height="16px"
                              />
                            }
                            onClick={() => {
                              setCreateDrug(true);
                            }}
                          >
                            Edit Patient
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Paper
                        elevation={0}
                        className={classes.rsOrderPadMedicationBtn}
                      >
                        <Grid
                          container
                          columnSpacing={2.5}
                          rowSpacing={3}
                          className={classes.rsOrderPadGrid}
                        >
                          <Grid
                            item
                            xs={12}
                            className={classes.orderDetailTitle}
                          >
                            <Typography variant="h3" medium color="secondary">
                              Order Details
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              placeholder="Order comment"
                              label="Order comment"
                              size="small"
                              name="comment"
                              value={values?.comment}
                              error={touched?.comment && errors?.comment}
                              helperText={touched?.comment && errors?.comment}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Grid display={"contents"}>
                              <Typography medium variant="h4">
                                Best Ordering Method *
                              </Typography>
                              <Grid
                                display={"flex"}
                                className={classes.rsMainGrid}
                                rowSpacing={1}
                                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                              >
                                <>
                                  {OrderingMethod?.map((item, index) => {
                                    return (
                                      <FormControlLabel
                                        error={
                                          touched?.ordering_method &&
                                          errors?.ordering_method
                                        }
                                        helperText={
                                          touched?.ordering_method &&
                                          errors?.ordering_method
                                        }
                                        onBlur={handleBlur}
                                        className={classes.labelWhiteSpaceNW}
                                        value={item}
                                        key={index}
                                        onClick={() => {
                                          setIsOpenOrderList(false);
                                          setFieldValue(
                                            "ordering_method",
                                            item?.type || ""
                                          );
                                          handleChange(
                                            "ordering_method",
                                            item?.type || ""
                                          );
                                        }}
                                        control={
                                          <Chip
                                            icon={item?.icon}
                                            checked={
                                              values?.ordering_method ==
                                              item.type
                                            }
                                            className={clsx(
                                              classes.chipMain,
                                              values?.ordering_method ==
                                                item.type
                                                ? classes.chipsFilled
                                                : classes.chips
                                            )}
                                            label={<div>{item?.item}</div>}
                                            color={
                                              values?.ordering_method ==
                                                item.type
                                                ? "primary"
                                                : "default"
                                            }
                                            variant={
                                              values?.ordering_method ==
                                                item.type
                                                ? "filled"
                                                : "outlined"
                                            }
                                          />
                                        }
                                      />
                                    );
                                  })}
                                </>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>
                  </>
                )}
              </Grid>
              {showWholeForm && (
                <>
                  <Grid container columnSpacing={2.5} rowSpacing={2}>
                    <Box display={"flex"} margin={"0 auto"}>
                      <Grid item xs={6} sm={6} md={6} lg={6}>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            handleDialog(
                              medications,
                              values?.number_of_medication
                            );
                          }}
                        >
                          View Order
                        </Button>
                      </Grid>
                      <Grid item xs={3} sm={6} md={6} lg={6}>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={createOrderPadData?.loading}
                          startIcon={
                            createOrderPadData?.loading && (
                              <CircularProgress color="white" size="20px" />
                            )
                          }
                          className={classes.rsOrderPadProceedBtn}
                        >
                          Proceed
                        </Button>
                      </Grid>
                    </Box>
                  </Grid>
                </>
              )}
            </form>
          )}
        </Grid>
      )}
    </>
  );
};

export default CreateNewRx;
